import React, { useEffect, useRef, useState } from "react";

// Parses a value string like "+29.23%", "1.14%", "604", "1,240" and animates
// the numeric portion when scrolled into view.
export default function CountUp({ value, duration = 1400, className = "" }) {
  const ref = useRef(null);
  const [display, setDisplay] = useState(value);
  const started = useRef(false);

  useEffect(() => {
    const str = String(value);
    const match = str.match(/-?[\d,]*\.?\d+/);
    if (!match) {
      setDisplay(str);
      return;
    }
    const numStr = match[0].replace(/,/g, "");
    const target = parseFloat(numStr);
    const decimals = (numStr.split(".")[1] || "").length;
    const hasComma = match[0].includes(",");
    const prefix = str.slice(0, match.index);
    const suffix = str.slice(match.index + match[0].length);

    const format = (n) => {
      let s = n.toFixed(decimals);
      if (hasComma) s = Number(s).toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
      return prefix + s + suffix;
    };

    setDisplay(format(0));

    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !started.current) {
        started.current = true;
        const t0 = performance.now();
        const tick = (now) => {
          const p = Math.min((now - t0) / duration, 1);
          const eased = 1 - Math.pow(1 - p, 3);
          setDisplay(format(target * eased));
          if (p < 1) requestAnimationFrame(tick);
          else setDisplay(format(target));
        };
        requestAnimationFrame(tick);
        obs.unobserve(el);
      }
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value, duration]);

  return <span ref={ref} className={className}>{display}</span>;
}
